import InputBox from "./InputBox";
import React from "react";

class AnswerInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      animation: "idle"
    };

    this.setAnimation = [...Array(5).keys()];
    this.clearInput = [...Array(5).keys()];
    this.current_flip = 0;
    this.flipNext = this.flipNext.bind(this);
    this.doBounce = this.doBounce.bind(this);
    this.clear = this.clear.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.props.submit(this.submit);
  }

  submit(correct) {
    if (correct) {
      this.flipNext();
    } else {
      this.setState({ animation: "shake" });
    }
  }

  flipNext() {
    if (this.current_flip < this.props.target.length) { 
      this.setAnimation[this.current_flip++]("flip-in");
    } 
  }

  doBounce() {
    Array.from(document.getElementsByClassName("input-box")).forEach((e, i) => {
      e.style.animationDelay = "".concat(100 * i, "ms");
      this.setAnimation[i]("bounce");
    });
    setTimeout(() => {
      this.props.swapInPuzzle();
      this.clear();
    }, 1800);
  }

  clear() {
    this.props.clearInput()
    this.setState({
      animation: "idle",
    });
    this.correct = false;
    Array.from(document.getElementsByClassName("input-box")).forEach((e, i) => {
      e.style.removeProperty("animation-delay");
      this.clearInput[i]();
    });
    this.current_flip = 0;
  }

  render() {
    return (
      <div
        className="letter-row answer-row"
        id="answer-row"
        data-animation={this.state.animation}
        onAnimationEnd={(e) => this.setState({ animation: "idle" })}
      >
        {[...Array(this.props.target.length).keys()].map(index => 
          <InputBox
            key={index}
            letter={this.props.input[index]}
            setAnimation={call => this.setAnimation[index] = call}
            clear={call => this.clearInput[index] = call}
            flipNext={this.flipNext}
            doBounce={index === this.props.target.length - 1 ? this.doBounce : () => {}}
          />
        )}
      </div>
    );
  }
}

export default AnswerInput;